import React, { useContext, useState, useRef } from "react";
import "./Tooltip.scss";
import { ReactComponent as Icon } from "../../assets/media/info.svg";
import { I18nContext } from "../../context";

/**
 * Tooltip
 * @param {Object} props
 * @param {String} props.text Tooltip content
 * @returns {React.ReactElement}
 */
function Tooltip({ text }) {
  const { locale } = useContext(I18nContext);
  const [isVisible, setIsVisible] = useState(false);
  const [positionValue, setPositionValue] = useState(0);
  const ref = useRef(null);

  const setPosition = (force = false) => {
    if (!isVisible && !force) {
      return;
    }

    const offset =
      0.5 * document.body.clientWidth -
      ref.current.getBoundingClientRect().left;

    setPositionValue(offset);
  };

  window.addEventListener("resize", () => {
    setPosition();
  });

  const toggleTooltip = (event) => {
    setPosition(true);
    setIsVisible(!isVisible);
  };

  return (
    <span className="Tooltip" ref={ref}>
      <button
        className="Tooltip__button"
        type="button"
        onClick={toggleTooltip}
        aria-haspopup="true"
        aria-expanded={isVisible}
        aria-label={locale.helpLabel}
      >
        <Icon className="Tooltip__button-icon" />
      </button>
      {isVisible ? (
        <span
          className="Tooltip__content"
          style={{
            marginLeft: `${positionValue}px`,
          }}
        >
          {text}
        </span>
      ) : null}
    </span>
  );
}

export default Tooltip;
